var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.864,
    height: 24.92,
    viewBox: "0 0 27.864 24.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45",
    transform: "translate(0.638 0.558)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85338",
    "data-name": "Path 85338",
    d: "M4.319,10.021c5.975-8.179,18.836-5.5,21.231,4.163l1.435-2.75a.889.889,0,1,1,1.573.831L25.794,17.5a.888.888,0,0,1-.982.444,1.883,1.883,0,0,1-.222-.08l-5.26-2.755a.9.9,0,0,1,.853-1.577L24,15.552a10.174,10.174,0,1,0-4.038,9.73.889.889,0,1,1,1.053,1.431,11.825,11.825,0,0,1-7.068,2.319c-9.676.084-15.429-11.276-9.631-19.011Z",
    transform: "translate(-1.998 -5.17)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.67989761f6534bce5f17a833102d2fea.svg";
export { ForwardRef as ReactComponent };